import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function StatsBanner() {
  return (
    <section className="py-10 md:py-12 bg-primary-500">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          <div>
            <div className="text-3xl md:text-4xl font-bold font-heading text-background-50">
              {siteInfo.stats.totalComics}
            </div>
            <div className="mt-1 text-sm text-background-50/80">韩漫大全</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold font-heading text-background-50">
              {siteInfo.stats.dailyUpdate}
            </div>
            <div className="mt-1 text-sm text-background-50/80">每日更新</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold font-heading text-background-50">
              {siteInfo.stats.registeredUsers}
            </div>
            <div className="mt-1 text-sm text-background-50/80">注册用户</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold font-heading text-background-50">
              {siteInfo.stats.dailyActiveUsers}
            </div>
            <div className="mt-1 text-sm text-background-50/80">日活用户</div>
          </div>
        </div>
      </div>
    </section>
  );
}